import api from "@/utils/axios";

export const subscribeNewsletter = async (payload) => {
  const res = await api.post("/newsletter/subscribe", payload);
  return res.data;
};
